import React from 'react'
import FavoriteTask from './Task'
import FavoriteUser from './User'
import FavoriteArticle from './Article'
import FavoritePeerChat from './PeerChat'
import FavoriteSession from './Session'

export type FavoriteCardProps = {
  favorite: APIFavorite
  filter: string
  searchValue: string
  draggable: boolean
  handleMoveFavorite: (start: string, end: string) => void
}

const ELEMENT_MAP: Record<APIFavorite['type'], React.FC<any>> = {
  task: FavoriteTask,
  user: FavoriteUser,
  article: FavoriteArticle,
  session: FavoriteSession,
  peer_chat: FavoritePeerChat
}

const FavoriteCard: React.FC<FavoriteCardProps> = props => {
  const Element = React.useMemo(() => {
    const fieldType = props.favorite.type

    if (fieldType in ELEMENT_MAP) {
      return ELEMENT_MAP[fieldType]
    }

    console.warn(`Unknown favorite type: ${fieldType}`)
    return null
  }, [props.favorite.type])

  if (!Element) {
    return null
  }

  return <Element {...props} />
}

export default FavoriteCard
